const pqrsRoutes = {
  adminPqrs: { path: '/pqrs' },
  myPqrs: { path: '/my-pqrs' }
};

export default pqrsRoutes;
